import { useQuery } from '@tanstack/react-query';
import { ApiReserveCheckoutProductsResponse, fetchReserveCheckoutProducts } from './apiFetchReserveCheckoutProducts';
import { Pagination } from '../../../../../models/Pagination';
import { AxiosError } from 'axios';
import { typedFailure } from '../../../checkout/utils/request-error';
import { PATH_RESERVE } from '../../../../store/constants';
import { useNotification } from '../../../../app-store/notification/useNotification';
import { GlobalReactQueryOptions } from '../../../../config';
import { useNavigate } from 'react-router-dom';

const RESERVE_CHECKOUT_PRODUCTS_QUERY = 'reserveCheckoutProducts';

export const useReserveCheckoutProducts = (reserveListId: string, pagination: Pagination) => {
    const { showNotificationWithInfo } = useNotification();
    const navigate = useNavigate();

    return useQuery<ApiReserveCheckoutProductsResponse, AxiosError>(
        [RESERVE_CHECKOUT_PRODUCTS_QUERY, reserveListId, pagination],
        () => fetchReserveCheckoutProducts(reserveListId, pagination),
        {
            ...GlobalReactQueryOptions,
            onError: error =>
                typedFailure(error, `${PATH_RESERVE}/${reserveListId}`, showNotificationWithInfo, navigate)
        }
    );
};
